/**
 * EN content for the "Antibes – Juan-les-Pins" private excursion.
 *
 * Role: English translation of slugs/antibes-juan-les-pins.ts, typed
 * `ExcursionPage` for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place names).
 */
import type { ExcursionPage } from "../slug-excursions";
import antibes from "@/assets/images/excursions/destinations/antibes.webp";

const page: ExcursionPage = {
  slug: "antibes-juan-les-pins",
  hero: {
    title: "Antibes – Juan-les-Pins Excursion",
    subtitle: "Old stone, ramparts and iconic beaches, departing from Cannes.",
    ctaPrimaryHref: "/en/reservation",
    ctaPrimaryLabel: "Book now",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Get a quote",
    image: antibes,
  },
  highlights: {
    title: "Highlights",
    items: [
      { text: "Ramparts, market and old town of Antibes" },
      { text: "Juan-les-Pins: beaches, pine grove, chic atmosphere" },
      { text: "Picasso Museum (subject to opening hours)" },
      { text: "Cap d'Antibes and viewpoints (optional)" },
    ],
  },
  itinerary: {
    title: "Sample itinerary",
    steps: [
      {
        title: "Antibes",
        description: "Ramparts, Provençal market, museum (optional).",
      },
      {
        title: "Juan-les-Pins",
        description: "Beaches, harbour, seafront promenade.",
      },
      {
        title: "Cap d'Antibes (optional)",
        description: "Viewpoints and photos.",
      },
    ],
  },
  practical: {
    title: "Practical information",
    items: [
      { label: "Duration", value: "3 to 5 hours" },
      { label: "Departure", value: "Cannes" },
      { label: "Season", value: "All year round" },
      { label: "Option", value: "Museum / viewpoints on request" },
    ],
  },
  seo: {
    title: "Antibes – Juan-les-Pins Excursion | Private Chauffeur",
    description:
      "Private excursion from Cannes to Antibes and Juan-les-Pins: ramparts, old town, Picasso Museum, iconic beaches and the Cap d'Antibes viewpoints.",
    canonical: "/en/excursions/antibes-juan-les-pins",
  },
};

export default page;
